import "../styles/QuoteDetails.css";
import QuoteHeader from "./QuoteHeader";
import QuoteVehicleInfo from "./QuoteVehicleInfo";
import QuoteCustomerInfo from "./QuoteCustomerInfo";
import QuoteStatusInfo from "./QuoteStatusInfo";
import QuoteWorkshopInfo from "./QuoteWorkshopInfo";
import ScheduleSelector from "./ScheduleSelector";

function QuoteDetails({ quote }) {
  if (!quote) return null;
  
  return (
    <div className="quote-details">
      <QuoteHeader quote={quote} />
      
      <div className="quote-content">
        <QuoteStatusInfo quote={quote} />
        <QuoteVehicleInfo quote={quote} />
        <QuoteCustomerInfo quote={quote} />
        <QuoteWorkshopInfo quote={quote} />
      </div>

      {(!quote?.schedules || quote?.schedules?.filter(s => s?.status != "rejected")?.length === 0) && <ScheduleSelector quote={quote} />}
    </div>
  );
}

export default QuoteDetails;
